import React from 'react';

import Page from 'components/Page';
import ToggleGallery from 'components/ToggleGallery';

const ToggleGalleryTemplate = ({ page: { acf: { gallery, set_1_name, set_2_name } } }) => {

    return (
        <Page>
            <ToggleGallery images={gallery} set1Name={set_1_name} set2Name={set_2_name} />
        </Page>
    );
};

export default ToggleGalleryTemplate;